import { render, staticRenderFns } from "./ValueWithTagsRenderer.vue?vue&type=template&id=4e926464&scoped=true"
import script from "./ValueWithTagsRenderer.vue?vue&type=script&lang=js"
export * from "./ValueWithTagsRenderer.vue?vue&type=script&lang=js"
import style0 from "./ValueWithTagsRenderer.vue?vue&type=style&index=0&id=4e926464&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e926464",
  null
  
)

export default component.exports